import { render, staticRenderFns } from "./PushMsg.vue?vue&type=template&id=4b6bc109&scoped=true&"
import script from "./PushMsg.vue?vue&type=script&lang=js&"
export * from "./PushMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bc109",
  null
  
)

export default component.exports